import InventoryIcon from '@mui/icons-material/Inventory'
import { Typography } from '@mui/material'
import { webApiService } from '@services/index'
import { useEffect, useState } from 'react'
import { SupplyContextType, useSupplyContext } from '../context/Supply.context'
import StockAllocation from './StockAllocation'

const Inventory = () => {
  const { supplyCtx } = useSupplyContext() as SupplyContextType
  const [data, setData] = useState<{ loading: boolean, listWarehouse: any[]}>({ loading: false, listWarehouse: [] })

  const loadData = async () => {
    setData({ ...data, loading: true })
    webApiService.getAlSupplyWarehouse().then((response) => {
      setData({ listWarehouse: response.data, loading: false })
    }).catch((error) => {
      setData({ listWarehouse: [], loading: false })
      console.log(error)
    })
  }

  const obtenerInsumo = (bodegas: any[], cantidades: any[], idBuscado: number) => {
    const bodega = bodegas.find(item => item.id === idBuscado)
    const quantity = cantidades.find(item => item.id_warehouse === idBuscado)?.quantity || 0

    return bodega ? { name: bodega.name, quantity } : { name: '', quantity }
  }

  useEffect(() => {
    loadData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className='row gy-3'>
      <div className='col-12 d-flex align-items-center justify-content-between'>
        <div>
          <Typography variant='h6' className='py-2 color-title'>
            <InventoryIcon className='color-azul' /> INVENTARIO
          </Typography>
        </div>
        <div>{supplyCtx.supply.inventory > 0 ? <StockAllocation listWarehouse={data.listWarehouse} /> : null}</div>
      </div>
      <div className='col-12'>
        {
          supplyCtx.supply.inventory > 0 && data.listWarehouse.map((item: any, idx: number) => {
            return (
              <div key={idx} className='d-flex justify-content-between mb-2 align-items-center border border-black bg-gris rounded p-2'>
                <div>{item.name}</div>
                <div>
                  <span className='badge text-bg-secondary'>{obtenerInsumo(data.listWarehouse, supplyCtx.supply.inventory_warehouse, Number(item.id)).quantity}</span>
                </div>
              </div>
            )
          })
        }
      </div>
    </div>
  )
}

export default Inventory
